<div
  class="eventq-file-dropzone"
  [class.eventq-file-dropzone--dragging]="dragging()"
  [class.eventq-file-dropzone--preview]="previews().length > 0"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  @if (previews().length > 0) {
    <div class="eventq-file-dropzone__previews" role="list" aria-label="Uploaded snapshots">
      @for (item of previews(); track item.url; let index = $index) {
        <div class="eventq-file-dropzone__card" role="listitem">
          <div class="eventq-file-dropzone__card-header">
            <span class="eventq-file-dropzone__card-label" [title]="item.label">{{ item.label }}</span>
            @if (!disabled()) {
              <button
                type="button"
                class="eventq-file-dropzone__remove"
                [attr.aria-label]="'Remove ' + item.label"
                (click)="removeAt(index, $event)"
              >
                <mat-icon aria-hidden="true">close</mat-icon>
              </button>
            }
          </div>
          <div class="eventq-file-dropzone__card-media">
            <img class="eventq-file-dropzone__card-image" [src]="item.url" [alt]="item.label" />
          </div>
        </div>
      }
      @if (!disabled()) {
        <label class="eventq-file-dropzone__add-card">
          <mat-icon aria-hidden="true">add</mat-icon>
          <span>Add</span>
          <input
            class="eventq-file-dropzone__input"
            type="file"
            [attr.accept]="accept()"
            [multiple]="multiple()"
            [disabled]="disabled()"
            (change)="onFileInputChange($event)"
          />
        </label>
      }
    </div>
  } @else {
    <label class="eventq-file-dropzone__content">
      <mat-icon class="eventq-file-dropzone__icon" aria-hidden="true">photo_library</mat-icon>
      <span class="eventq-file-dropzone__label">{{ label() }}</span>
      @if (hint()) {
        <span class="eventq-file-dropzone__hint">{{ hint() }}</span>
      }
      <input
        class="eventq-file-dropzone__input"
        type="file"
        [attr.accept]="accept()"
        [multiple]="multiple()"
        [disabled]="disabled()"
        (change)="onFileInputChange($event)"
      />
    </label>
  }
</div>
